import { c as _c } from "react/compiler-runtime";
import { useThemeMode } from '@morpho-org/ui-v6/hooks';
import { memo } from 'react';
import HowItWorksBorrowGraphics from './HowItWorksBorrowGraphics.tsx';
interface HowItWorksBorrowAnimationProps {
  animationStep: number;
  base: string;
}
const HowItWorksBorrowAnimation = t0 => {
  const $ = _c(4);
  const {
    animationStep,
    base
  } = t0;
  const themeMode = useThemeMode();
  let t1;
  if ($[0] !== animationStep || $[1] !== base || $[2] !== themeMode) {
    t1 = <div className="max-xl:p-md relative aspect-[0.84] max-h-full max-w-full overflow-hidden p-[40px] max-lg:p-0 max-md:absolute max-md:h-full max-md:p-[5%]"><HowItWorksBorrowGraphics base={base} selectedPart={animationStep} backgroundFillColor="var(--popover)" textFillColor="var(--foreground)" pathsFillColor="var(--foreground)" themeMode={themeMode} /></div>;
    $[0] = animationStep;
    $[1] = base;
    $[2] = themeMode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default memo(HowItWorksBorrowAnimation);